import resourceWrapper from './resourceWrapper';
const resources = [
    {
        name: 'getVerifyCode',
        method: 'get',
        url: `https://${
            import.meta.env.VITE_INSIGHT_SERVER_URL
        }/ptmindservice/user/refindPassword/verifyCodeImg`
    },
    {
        name: 'sendForgetEmail',
        method: 'get',
        url: `https://${
            import.meta.env.VITE_INSIGHT_SERVER_URL
        }/ptmindservice/user/refindPassword/sendEmail?email={email}&verifyCode={verifyCode}&type=normal`
    },
    {
        name: 'getQrcode',
        method: 'get',
        url: `${
            import.meta.env.VITE_ENGAGE_SERVICE_URL
        }/engage-service/auth/google/qrcode?username={username}&identifier=ptengine`
    },
    {
        name: 'activeAuthentication',
        method: 'post',
        url: `${import.meta.env.VITE_ENGAGE_SERVICE_URL}/engage-service/auth/google/verify`
    },
    {
        name: 'getAuthStatus',
        method: 'get',
        url: `https://${
            import.meta.env.VITE_INSIGHT_SERVER_URL
        }/ptmindservice/service/secondVerification/secret/uid/{uid}`
    },
    {
        name: 'updateAuthStatus',
        method: 'post',
        url: `https://${
            import.meta.env.VITE_INSIGHT_SERVER_URL
        }/ptmindservice/service/secondVerification/secret`
    },
    {
        name: 'inactiveAuthentication',
        method: 'delete',
        url: `https://${
            import.meta.env.VITE_INSIGHT_SERVER_URL
        }/ptmindservice/service/secondVerification/secret/uid/{uid}`
    },
    {
        name: 'invoice',
        method: 'put',
        url: `https://${
            import.meta.env.VITE_INSIGHT_SERVER_URL
        }/ptmindservice/service/accountSetting/user/invoice`
    }
];
export default resourceWrapper(resources);
